import cookie from './cookie';
import env from './env';
import {
  delQueStr,
  doLoadScript,
  filterXSS,
  getCoverTag,
  getUrlParam,
  hasOwn,
  loadScript,
  loadScript2,
  setUrlParam,
} from './util.esm';

function getUin(uinStr) {
  let ret = '';
  if (uinStr) {
    const reg = /^o0*/g;
    if (reg.test(uinStr)) {
      ret = parseInt(uinStr.replace(/^o0*/g, ''), 10);
    } else {
      ret = uinStr;
    }
  }
  return ret;
}

function getUserid() {
  // 根据用户id缓存信息
  const accountType = cookie.get('main_login');
  let uid = '';
  if (accountType === 'wx') {
    uid = cookie.get('openid');
  } else if (accountType === 'qq') {
    uid = cookie.get('uin') || cookie.get('luin');
    uid = getUin(uid);
  }
  return uid;
}

/**
 * 设置promise超时时间
 * https://advancedweb.hu/how-to-add-timeout-to-a-promise-in-javascript/
 * @param {Number} milliseconds
 * @param {Promise} promise
 * @param {*} exception
 * @returns Promise
 */
export function promiseTimeout(promise, milliseconds, exception = new Error('promise timeout')) {
  let timer;
  return Promise.race([
    promise,
    new Promise((_r, reject) => timer = setTimeout(reject, milliseconds, exception)),
  ])
    .finally(() => clearTimeout(timer));
}

export default {
  getUrlParam,
  setUrlParam,
  delQueStr,
  getCoverTag,
  hasOwn,
  promiseTimeout,
  loadScript,
  loadScript2,
  doLoadScript,
  /**
   * 检测是否公司域名
   *
   * @param {string}
   *          sUrl
   * @return {}
   */
  vaildURL(sUrl) {
    return !!(/^(https?:\/\/)?[\w\-.]+\.(qq|paipai|soso)\.com($|\/|\\)/i.test(sUrl)
    || /^[\w][\w/.\-_%]+$/i.test(sUrl)
    || /^[/\\][^/\\]/i.test(sUrl));
  },
  filterXSS,
  /**
   * 接下来要用到的正则
   */

  /* eslint camelcase: ["error", {properties: "never"}] */
  RegExps: {
    nl2br: /\n/g,
    s2nb: /[\x20]{2}/g,
    escHTML: {
      re_amp: /&/g,
      re_lt: /</g,
      re_gt: />/g,
      re_apos: /\x27/g,
      re_quot: /\x22/g,
    },
    restHTML: {
      re_amp: /&amp;/g,
      re_lt: /&lt;/g,
      re_gt: /&gt;/g,
      re_apos: /&(?:apos|#0?39);/g,
      re_quot: /&quot;/g,
    },
  },
  /**
   * 通用替换
   *
   * @ignore
   * @param {string} s 需要进行替换的字符串
   * @param {String/RegExp} p 要替换的模式的 RegExp 对象
   * @param {string} r 一个字符串值。规定了替换文本或生成替换文本的函数。
   * @example
   *          this.commonReplace(str + "", this.RegExps.trim, '');
   * @returns {string} 处理结果
   */
  commonReplace(s, p, r) {
    return s.replace(p, r);
  },
  /**
   * 通用系列替换
   *
   * @ignore
   * @param {string} s 需要进行替换的字符串
   * @param {Object} l RegExp对象hashMap
   * @example
   *          this.listReplace(str,regHashmap);
   * @returns {string} 处理结果
   */
  listReplace(s, l) {
    if (this.isHashMap(l)) {
      Object.keys(l).forEach((i) => {
        s = this.commonReplace(s, l[i], i);
      });
      return s;
    }
    return `${s}`;
  },
  /**
   * 制造html中换行符
   *
   * @param {string} str 目标字符串
   * @example
   *          this.nl2br(str);
   * @returns {string} 结果
   */
  nl2br(str) {
    return this.commonReplace(`${str}`, this.RegExps.nl2br, '<br />');
  },
  /**
   * 制造html中空格符，爽替换
   *
   * @param {string} str 目标字符串
   * @example
   *          this.s2nb(str);
   * @returns {string} 结果
   */
  s2nb(str) {
    return this.commonReplace(`${str}`, this.RegExps.s2nb, '&nbsp;&nbsp;');
  },
  /**
   * htmlEscape
   *
   * @param {string} str 目标串
   * @example
   *          this.escHTML(str);
   * @returns {string} 结果
   */
  escHTML(str) {
    const t = this.RegExps.escHTML;
    return this.listReplace(`${str}`, {
      /*
       * '&' must be
       * escape first
       */
      '&amp;': t.re_amp,
      '&lt;': t.re_lt,
      '&gt;': t.re_gt,
      '&#039;': t.re_apos,
      '&quot;': t.re_quot,
    });
  },
  /**
   * xhtmlEscape还原
   *
   * @param {string} str 目标串
   * @returns {string} 结果
   */
  restHTML(str) {
    const t = this.RegExps.restHTML;
    return this.listReplace(`${str}`, {
      /*
       * '&' must be
       * escape last
       */
      '<': t.re_lt,
      '>': t.re_gt,
      '\x27': t.re_apos,
      '\x22': t.re_quot,
      '&': t.re_amp,
    });
  },
  /**
   * 是否哈希表结构
   *
   * @param {object} o 目标
   * @returns {boolean} 结果
   * @example QZFL.lang.isHashMap(obj);
   */
  isHashMap(o) {
    return this.getType(o) === 'object';
  },
  /**
   * 获取对象类型
   *
   * @param {object} obj 任意一个数据
   * @return {string} 返回对象类型字符串

   * @example
   * QZFL.object.getType([1,2,3]);
   */
  getType(obj) {
    if (obj === null) {
      return 'null';
    }
    if (obj === undefined) {
      return 'undefined';
    }
    return Object.prototype.toString
      .call(obj)
      .slice(8, -1)
      .toLowerCase();
  },
  /**
   * 获取平台
   * @return {[type]} [description]
   */
  getPlat() {
    const data = {
      plat: 0,
      channel: 0,
    };
    const ua = navigator.userAgent;
    if (ua.indexOf('Android') !== -1) {
      data.plat = 108;
    } else if (ua.indexOf('iPhone') !== -1) {
      data.plat = 107;
    } else if (ua.indexOf('iPad') !== -1) {
      data.plat = 105;
    }
    if (ua.indexOf('MicroMessenger') !== -1) {
      const from = this.getUrlParam('from');
      if (from === 'timeline') {
        data.channel = 8;
      } else {
        data.channel = 16;
      }
    } else if (ua.indexOf('TXMicroBlog') !== -1) {
      data.channel = 1;
    } else if (ua.indexOf('Weibo') !== -1) {
      data.channel = 4;
    } else if (/ QQ\//.test(ua)) {
      data.channel = 64;
    } else if (/ Qzone\//.test(ua)) {
      data.channel = 2;
    }

    return data;
  },
  date: {
    format: (function () {
      const fnMap = {
        Y(d) {
          return d.getFullYear();
        },
        m(d) {
          return pad(d.getMonth() + 1);
        },
        n(d) {
          return d.getMonth() + 1;
        },
        d(d) {
          return pad(d.getDate());
        },
        e(d) {
          return d.getDate();
        },
        H(d) {
          return pad(d.getHours());
        },
        i(d) {
          return pad(d.getMinutes());
        },
        s(d) {
          return pad(d.getSeconds());
        },
      };

      const pattern = Object.keys
        ? Object.keys(fnMap).join('')
        : (function () {
          let r = '';
          Object.keys(fnMap).forEach((k) => {
            r += k;
          });
          return r;
        }());

      const patternRegExp = new RegExp(`[${pattern}]`, 'g');

      function pad(n) {
        return n > 9 ? n : `0${n}`;
      }

      /**
       *@param date Date|Integer|String:'YYYY-MM-DD hh:ii:ss'|String:/^\d+$/
       *@return String
       */
      return function (date, format) {
        let dateObj;
        if (/^\d+$/.test(date)) {
          dateObj = new Date(parseInt(date, 10));
        } else if (typeof date === 'string') {
          dateObj = new Date(date.replace(/-/g, '/'));
        } else if (Object.prototype.toString.call(date) === '[object Date]') {
          dateObj = date;
        }
        if (!dateObj || dateObj.toString() === 'Invalid Date') {
          throw new Error(`[hlw.date.format]the input cannot be converted to date object(${date})`);
        }
        return format.replace(patternRegExp, (k) => {
          if (typeof fnMap[k] === 'function') {
            return fnMap[k](dateObj);
          }
          return k;
        });
      };
    }()),
  },

  /**
   * 设置localStorage缓存
   * @param key
   * @param data
   */
  setCache(key, data) {
    if (localStorage) {
      localStorage.setItem(key, JSON.stringify(data));
    }
  },

  /**
   * 清除localStorage缓存
   * @param key
   * @returns {*}
   */
  getCache(key) {
    let value;
    if (localStorage) {
      try {
        value = localStorage.getItem(key);
        if (value !== null) {
          value = JSON.parse(value);
        }
      } catch (e) {}
    }
    return value;
  },

  /**
   * 获取用户相关的localStorage缓存
   * @param key
   * @return {*}
   */
  getUserCache(key) {
    return this.getCache(getUserid() + key);
  },

  /**
   * 设置用户相关的localStorage缓存
   * @param key
   * @param data
   * @return {*}
   */
  setUserCache(key, data) {
    return this.setCache(getUserid() + key, data);
  },
  isThenable(o) {
    return (
      typeof o === 'object'
      && o.then
      && o.catch
      && typeof o.then === 'function'
      && typeof o.catch === 'function'
    );
  },

  /**
   * 当电脑访问时跳转到一个带二维码的web页面
   * @param qrCodePicUrl 二维码地址
   * @param pageTitle 页面标题
   * @param pagePic 页面示例图
   * @param pageDesc 二维码下方描述
   * @param pageUrl 二维码对应的跳转地址
   */
  webQrCode({
    qrCodePicUrl,
    pageTitle = document.title,
    pagePic = '',
    pageDesc = '',
    pageUrl = location.href,
  }) {
    const isWeb =      env.isWin
      || (env.isMac && !env.isIphone && !env.isIpad && !env.isAndroid);
    if (isWeb) {
      window.location.href = `//film.qq.com/weixin/v3/web-to-phone/index.html?url=${encodeURIComponent(pageUrl)}&desc=${encodeURIComponent(pageDesc)}&pic=${encodeURIComponent(pagePic)}&title=${encodeURIComponent(pageTitle)}&qrcode=${encodeURIComponent(qrCodePicUrl)}`;
    }
  },

  /**
   * 生成二维码链接
   * @param url 链接地址或urlparam对象或空
   */
  genQrCodeUrl(url, isNeedShort = 1, margin = 2) {
    let base = '//pay.video.qq.com/fcgi-bin/qrencode';
    if (typeof url === 'string') {
      base = this.setUrlParam('url', url, base);
      base = this.setUrlParam('isNeedShort', isNeedShort, base);
      base = this.setUrlParam('margin', margin, base);
      return base;
    } if (typeof url === 'object') {
      Object.keys(url).forEach((key) => {
        base = this.setUrlParam(key, url[key], base);
      });
      return base;
    }
    return this.genQrCodeUrl(location.href);
  },
  /**
   * 昵称隐藏打点
   * @param {String} nickname 昵称
   * @param {String} defaultNick 为空时默认昵称
   */
  hideNick(nickname, defaultNick = '') {
    if (!nickname) {
      return defaultNick;
    }
    const nickArr = Array.from(nickname);
    if (nickArr.length === 1) return '*';
    if (nickArr.length === 2) return `${nickArr[0]}*`;
    if (nickArr.length === 3) {
      return `${nickArr[0]}*${nickArr[nickArr.length - 1]}`;
    }
    return `${nickArr[0]}**${nickArr[nickArr.length - 1]}`;
  },
  /**
   * 格式化超长数字
   * @param {Number} value
   */
  formatNum(value) {
    if (+value < 1e4) {
      return value;
    } if (value < 1e5) {
      return `${parseInt(value / 1e2, 10) / 100}w`;
    } if (value < 1e6) {
      return `${parseInt(value / 1e3, 10) / 10}w`;
    } if (+value < 1e8) {
      return `${Math.floor(+value / 1e4)}w`;
    }
    return `${Math.floor(+value / 1e6) / 10}kw`;
  },
};

export {
  delQueStr,
  filterXSS,
  getCoverTag,
  getUrlParam,
  hasOwn,
  loadScript,
  loadScript2,
  setUrlParam,
  sleep,
} from './util.esm';
